/* Disable cart UI and block add-to-cart actions
   - Removes/hides common cart buttons, icons and links
   - Prevents form submits and clicks that target /cart or /checkout
   - Observes DOM to remove dynamic additions
*/
(function(){
  var selectors = [
    'button[name="add"]',
    'button[data-pf-type^="ProductATC"]',
    'button[data-add-to-cart]',
    '.add-to-cart',
    '.product-form__cart-submit',
    '.product-form__add-to-cart',
    '.header__icon--cart',
    '.cart-icon-bubble',
    '.cart-text',
    '.icon-cart',
    '.icon-cart-10',
    '.icon-cart-11',
    '.icon-cart-empty',
    'a[href*="/cart"]',
    'a[href*="/checkout"]',
    '.quick-cart',
    '.side-cart',
    '.halo-side-cart',
    '.cart-drawer',
    '.card-action.has-compare',
    'form[action*="/cart/add"]',
    'a.button-ATC',
    'a.button.button-ATC',
    '.add-to-cart-btn',
    '[data-btn-addtocart]',
    '.variants-popup',
    '.variants-popup-content',
    '.paypal-button-row',
    '.paypal-button',
    '.card-compare',
    '.card-compare-wrapper',
    '.compare-button',
    '.compare-checkbox',
    '.compare-label'
  ];

  function removeMatches(){
    selectors.forEach(function(sel){
      try{ document.querySelectorAll(sel).forEach(function(el){ el.remove(); }); }
      catch(e){}
    });
    // also remove any form whose action targets cart/add
    try{ document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){ f.remove(); }); }catch(e){}
  }

  function blockEventIfCartTarget(e){
    var el = e.target.closest && e.target.closest('a,button,form');
    if(!el) return false;
    var href = el.getAttribute && (el.getAttribute('href') || '');
    var action = el.getAttribute && (el.getAttribute('action') || '');
    if(href.indexOf('/cart') !== -1 || href.indexOf('/checkout') !== -1) return true;
    if(action.indexOf('/cart') !== -1 || action.indexOf('/cart/add') !== -1) return true;
    if(el.matches && ( el.matches('button[name="add"]') || (el.getAttribute && el.getAttribute('data-pf-type') && el.getAttribute('data-pf-type').indexOf('ProductATC') === 0 ) )) return true;
    return false;
  }

  document.addEventListener('DOMContentLoaded', function(){
    removeMatches();

    // prevent form submits that add to cart
    document.addEventListener('submit', function(e){
      try{
        var form = e.target;
        var action = form && form.action ? form.action : '';
        if(action.indexOf('/cart') !== -1 || action.indexOf('/cart/add') !== -1){
          e.preventDefault();
          e.stopImmediatePropagation();
          form.remove && form.remove();
          return false;
        }
      }catch(err){}
    }, true);

    // prevent compare checkbox interactions
    document.addEventListener('change', function(e){
      try{
        if(e.target && e.target.classList && e.target.classList.contains('compare-checkbox')){
          e.preventDefault();
          e.stopImmediatePropagation();
          e.target.checked = false;
          return false;
        }
      }catch(err){}
    }, true);

    // block clicks on cart/checkout buttons/links and PayPal/Quick-add anchors
    document.addEventListener('click', function(e){
      try{
        var shouldBlock = blockEventIfCartTarget(e);
        var el = e.target.closest && e.target.closest('a,button');
        if(el && (el.matches && (el.matches('.add-to-cart-btn') || el.matches('.button-ATC') || el.matches('.paypal-button') || el.matches('[data-btn-addtocart]')))) shouldBlock = true;
        if(shouldBlock){
          e.preventDefault();
          e.stopPropagation();
          el && el.remove && el.remove();
        }
      }catch(err){}
    }, true);

    // Observe for dynamic additions and remove them
    var mo = new MutationObserver(function(){ removeMatches(); });
    if(document.body) mo.observe(document.body, {childList:true, subtree:true});
  });
})();
